import { EInfrastructureActionType, ISetFeaturesCountPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setVisibleFeaturesCount = actionGenerator<
  EInfrastructureActionType.SetVisibleFeaturesCount,
  ISetFeaturesCountPayload
>(EInfrastructureActionType.SetVisibleFeaturesCount);
